export const GET_PROMO_QUORA = 'GET_PROMO_QUORA';
export const SET_PROMO_QUORA = 'SET_PROMO_QUORA';
export const ERROR_PROMO_QUORA = 'ERROR_PROMO_QUORA';